import { BaseService } from './../../../core/services/base.service';
import { HelperService } from './../../../core/services/helper.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Request } from '@optsolservices/ngx-data-table-with-search-criteria';

@Component({
  selector: 'app-pos-search-customer-dialog',
  templateUrl: './pos-search-customer-dialog.component.html',
  styleUrls: ['./pos-search-customer-dialog.component.scss']
})
export class PosSearchCustomerDialogComponent implements OnInit {
  customersTableConfigRequest: Request = null;
  customersTableDataRequest: Request = null;
  customersSearchCriteriaConfigRequest: Request = null;

  stockCodeToAdd: string;

  selectedKeys: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<PosSearchCustomerDialogComponent>,
    private helperService: HelperService,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.customersTableConfigRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_customers_table_config'),
      resultField: 'data',
      body: {

      }
    };

    this.customersSearchCriteriaConfigRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_customers_search_criteria'),
      resultField: 'data',
      body: {
        procurementHeaderId: this.data.procurementHeaderId,
      }
    };

    this.customersTableDataRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_customers_table_content'),
      resultField: 'data',
      body: this.data
    };
  }

  actionButtonClicked(event: any): void {
    this.baseService.executeCommand<any>('portal_sales_order_header_customer_code_modify', { salesOrderHeaderId: this.data.salesOrderHeaderId, customerCode: event?.data?.customerCode, useCashCustomer: false})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }

  close() {
    this.dialogRef.close();
  }

}
